<template>
  <a-input
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    @keydown="onKeyDown"
    @paste="onPaste"
    @change="onChange"
  />
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: String,
    placeholder: String,
    disabled: Boolean,
  },
  methods: {
    isValid(value = '') {
      const pattern = /(\W|\d)+/g;
      return !pattern.test(value) && !value.includes('_');
    },
    onKeyDown(e) {
      const { key } = e;
      if (this.isValid(key) || key === ' ' || key === '-') {
        this.$emit('keydown', e);
      } else {
        e.preventDefault();
      }
    },
    onPaste(e) {
      const text = (e.originalEvent || e).clipboardData.getData('text/plain');
      if (this.isValid(text)) {
        this.$emit('paste', e);
      } else {
        e.preventDefault();
      }
    },
    onChange(e) {
      this.$emit('change', e.target.value);
    },
  },
};
</script>
